import axios from 'axios';
import { API_BASE_URL } from '../config';

const instance = axios.create();
instance.defaults.baseURL = API_BASE_URL;

let snackbarHandler = null;

instance.setSnackbarHandler = handler => {
  snackbarHandler = handler;
};

instance.interceptors.response.use(
  response => response,
  error => {
    const status = error && error.response && error.response.status;
    if (status === 403 && typeof snackbarHandler === 'function') {
      snackbarHandler('Keine Berechtigung', { variant: 'error', autoHideDuration: 3000 });
    }
    return Promise.reject(error);
  }
);

export default instance;
